import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCommentsViewFilters, setCommentsViewHiddenColumns } from '../../redux/actions'
import { RootState } from '../../redux/types'
import { CommentsViewColumnId, CommentsViewFiltersState } from '../../components/CommentsView/CommentsView.types'

export const useCommentsViewFiltersStorage = () => {
    const dispatch = useDispatch()
    const filters = useSelector((state: RootState) => state.commentsViewFilters)

    const updateHiddenColumns = useCallback(
        (hiddenColumnIds: CommentsViewColumnId[]) => {
            dispatch(setCommentsViewHiddenColumns(hiddenColumnIds))
        },
        [dispatch]
    )

    const updateFilters = useCallback(
        (filtersState: CommentsViewFiltersState) => {
            dispatch(setCommentsViewFilters(filtersState))
        },
        [dispatch]
    )

    return {
        filters,
        updateFilters,
        updateHiddenColumns,
    }
}
